var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!../../../node_modules/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./DonateWidget.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-a8754eb0\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!../../../node_modules/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./DonateWidget.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/product/DonateWidget.vue
// module id = 284
// module chunks = 0